import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import api from "../services/api";

const ACCESS_TOKEN_KEY = "rmc2.access_token";

const ProtectedRoute = ({ children }) => {
  const [isChecking, setIsChecking] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const location = useLocation();

  useEffect(() => {
    let isActive = true;
    const token = localStorage.getItem(ACCESS_TOKEN_KEY);
    console.debug("[ProtectedRoute] path:", location.pathname, "token:", !!token);

    if (!token) {
      if (isActive) {
        setIsAuthorized(false);
        setIsChecking(false);
      }
      return () => {
        isActive = false;
      };
    }

    api
      .post(
        "/validate-token",
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(() => {
        console.debug("[ProtectedRoute] token valid");
        if (isActive) {
          setIsAuthorized(true);
          setIsChecking(false);
        }
      })
      .catch((error) => {
        console.debug(
          "[ProtectedRoute] token invalid",
          error?.response?.status,
          error?.response?.data
        );
        localStorage.removeItem(ACCESS_TOKEN_KEY);
        if (isActive) {
          setIsAuthorized(false);
          setIsChecking(false);
        }
      });

    return () => {
      isActive = false;
    };
  }, [location.pathname]);

  if (isChecking) {
    return null;
  }

  if (!isAuthorized) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
